var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-kw",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h682.7v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#a)",
    transform: "scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.6h1024v170.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f31830",
    d: "M0 341.3h1024V512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d941",
    d: "M0 0h1024v170.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v512l255.4-170.7.6-170.8L0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKw);
export default __webpack_public_path__ + "static/media/kw.72e00b08c4eb05a929ad857accc40da5.svg";
export { ForwardRef as ReactComponent };